import Header from './Public/HomePage/Header';
import { GlobalRender } from './helper/function'
import Aboutus from "./Public/HomePage/about";
import Capabilities from "./Public/HomePage/Capabilities";
import Career from "./Public/HomePage/Career";
import CareerDetail from "./Public/HomePage/CareerDetail";
import Contactus from "./Public/HomePage/Contactus";
import CookiePolicy from "./Public/HomePage/CookiePolicy";
import Customers from "./Public/HomePage/Customers";
import Demosuccess from "./Public/HomePage/Enquerysuccess";
import Appointment from "./Public/HomePage/Features/Appointment";
import Attendance from "./Public/HomePage/Features/Attendance";
import ChartsReporting from "./Public/HomePage/Features/ChartsReporting";
import Chat from "./Public/HomePage/Features/Chat";
import ClientManage from "./Public/HomePage/Features/ClientManage";
import Employee from "./Public/HomePage/Features/Employee";
import HrManagement from "./Public/HomePage/Features/HrManagement";
import Leads from "./Public/HomePage/Features/Leads";
import MobileAccess from "./Public/HomePage/Features/MobileAccess";
import PaymentExpense from "./Public/HomePage/Features/PaymentExpense";
import Task from "./Public/HomePage/Features/Task";
import Theme from "./Public/HomePage/Features/Theme";
import TimeTracking from "./Public/HomePage/Features/TimeTracking";
import Todo from "./Public/HomePage/Features/Todo";
import HomePage from "./Public/HomePage/HomePage";
import Privacy from "./Public/HomePage/PrivacyPolicy";
import Public404 from "./Public/HomePage/Public404";
import Security from "./Public/HomePage/Security";
import SiteMap from "./Public/HomePage/SiteMap";
import Solutions from "./Public/HomePage/Solutions";
import CAManagement from "./Public/HomePage/Solutions/CAManagement";
import Construction from "./Public/HomePage/Solutions/Construction";
import ConsultingServices from "./Public/HomePage/Solutions/ConsultingServices";
import Education from "./Public/HomePage/Solutions/Education";
import Enterprise from "./Public/HomePage/Solutions/Enterprise";
import Law from "./Public/HomePage/Solutions/Law";
import Manufacture from "./Public/HomePage/Solutions/Manufacture";
import Marketing from "./Public/HomePage/Solutions/Marketing";
import RealEstate from "./Public/HomePage/Solutions/RealEstate";
import SoftwareDevelopment from "./Public/HomePage/Solutions/SoftwareDevelopment";
import Startup from "./Public/HomePage/Solutions/Startup";
import Testing from "./Public/HomePage/Solutions/Testing";
import Team from "./Public/HomePage/Team";
import TermsofService from "./Public/HomePage/TermsofService";
import Pricing from "./Public/HomePage/Pricing";
import PackageDetail from './Public/HomePage/PlanDetails'
import PaymentStatus from './Public/HomePage/PaymentSuccess'
import UpcomingEvents from './Public/HomePage/UpcomingEvents'
import RequestForm from './Public/HomePage/RequestForm'
import Blogs from './Public/Blog/Blog';
import BlogDetail from './Public/Blog/BlogDetails'
import Docs from './Public/HomePage/Features/Docs';
import Hospitality from './Public/HomePage/Solutions/Hospitality';


const Route = [
    {
        element: <GlobalRender />,
        children: [
            {
                path: '/',
                element: <Header/>,
                children: [
                    {
                        index: true,
                        element: <HomePage />
                    },
                    {
                        path: "enquiry-raised",
                        element: <Demosuccess />,
                    },
                    {
                        path: "pricing",
                        element: <Pricing />,
                    },
                    {
                        path: "plan/:currencyId/:packageId",
                        element: <PackageDetail />,
                    },
                    {
                        path: "transaction/:transactionId",
                        element: <PaymentStatus />,
                    },
                    {
                        path: "solutions",
                        element: <Solutions />,
                    },
                    {
                        path: "customers",
                        element: <Customers />,
                    },
                    {
                        path: "about-us",
                        element: <Aboutus />,
                    },
                    {
                        path: "features/appointment",
                        element: <Appointment />,
                    },
                    {
                        path: "features/attendance-management-software",
                        element: <Attendance />,
                    },
                    {
                        path: "features/charts-reporting",
                        element: <ChartsReporting />,
                    },
                    {
                        path: "features/team-chat",
                        element: <Chat />,
                    },
                    {
                        path: "features/client-management-software",
                        element: <ClientManage />,
                    },
                    {
                        path: "features/employee-documentation",
                        element: <Docs />,
                    },
                    {
                        path: "features/employee-management-software",
                        element: <Employee />,
                    },
                    {
                        path: "features/lead-management-software",
                        element: <Leads />,
                    },
                    {
                        path: "features/mobile-access",
                        element: <MobileAccess />,
                    },
                    {
                        path: "features/payment-expense",
                        element: <PaymentExpense />,
                    },
                    {
                        path: "features/task-management-software",
                        element: <Task />,
                    },
                    {
                        path: "features/time-tracking-software",
                        element: <TimeTracking />,
                    },
                    {
                        path: "features/todo-list",
                        element: <Todo />,
                    },
                    {
                        path: "features/theme-customizations",
                        element: <Theme />,
                    },
                    {
                        path: "features/hr-management-software",
                        element: <HrManagement />,
                    },
                    {
                        path: "solutions/construction",
                        element: <Construction />,
                    },
                    {
                        path: "solutions/consulting-services",
                        element: <ConsultingServices />,
                    },
                    {
                        path: "solutions/education",
                        element: <Education />,
                    },
                    {
                        path: "solutions/enterprise",
                        element: <Enterprise />,
                    },
                    {
                        path: "solutions/law",
                        element: <Law />,
                    },
                    {
                        path: "solutions/manufacture",
                        element: <Manufacture />,
                    },
                    {
                        path: "solutions/marketing",
                        element: <Marketing />,
                    },
                    {
                        path: "solutions/real-estate",
                        element: <RealEstate />,
                    },
                    {
                        path: "solutions/software-development",
                        element: <SoftwareDevelopment />,
                    },
                    {
                        path: "solutions/startup",
                        element: <Startup />,
                    },
                    {
                        path: "solutions/testing",
                        element: <Testing />,
                    },
                    {
                        path: "solutions/chartered-accountant",
                        element: <CAManagement />,
                    },
                     {
                        path: "solutions/hospitality",
                        element: <Hospitality />,
                    },
                    {
                        path: "capabilities",
                        element: <Capabilities />,
                    },
                    {
                        path: "Demosuccess",
                        element: <Demosuccess />,
                    },
                    {
                        path: "career",
                        element: <Career />,
                    },
                    {
                        path: "careerdetail",
                        element: <CareerDetail />,
                    },
                    {
                        path: "contact-us",
                        element: <Contactus />,
                    },
                    {
                        path: "upcomingevent",
                        element: <UpcomingEvents />,
                    },
                    {
                        path: "cookie-policy",
                        element: <CookiePolicy />,
                    },
                    {
                        path: "privacy-policy",
                        element: <Privacy />,
                    },
                    {
                        path: "our-team",
                        element: <Team />,
                    },
                    {
                        path: "security",
                        element: <Security />,
                    },
                    {
                        path: "terms-of-service",
                        element: <TermsofService />,
                    },
                    {
                        path: "sitemap.html",
                        element: <SiteMap />,
                    },
                    {
                        path: "demo-request",
                        element: <RequestForm />,
                    },
                    {
                        path: 'blog',
                        element: <Blogs />
                    },
                    {
                        path: "blog/categorie/:slug",
                        element: <Blogs />,
                    },
                    {
                        path: 'blog/:slug',
                        element: <BlogDetail />
                    },
                ]
            },
            {
                path: "*",
                element: <Public404 />,
            },
            {
                path: "404",
                element: <Public404 />,
            },
        ]
    }
]
export default Route;